<template>
  <div class="container-fluid">
    <div class="row">
      <SideBarLeft></SideBarLeft>
      <div class="col order-1 order-lg-2">
        <div class="row">
          <transition name="fade">
            <router-view :key="$route.params.lecture" @loginModal="loginModal"></router-view>
          </transition>
        </div>
      </div>
      <SideBarRight></SideBarRight>
    </div>
    <PasswordLogin ref="passwordLogin"></PasswordLogin>

    <!-- Bootstrap Modal for Congratulations -->
    <div ref="congratsModal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('Congratulations!') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ $t('All lectures marked as completed') }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="hideCongratsModal">{{ $t('Ok') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBarLeft from './../components/SideBarLeft'
import SideBarRight from './../components/SideBarRight'
import confetti from 'canvas-confetti'
import PasswordLogin from './../components/PasswordLogin'
import _ from 'lodash'

export default {
  components: {
    SideBarLeft,
    SideBarRight,
    PasswordLogin,
  },
  data() {
    return {
      congratsModalInstance: null,
    }
  },
  mounted() {
    this.listenForIframeMessages()
    // Initialize Bootstrap modal instance
    this.congratsModalInstance = new window.bootstrap.Modal(this.$refs.congratsModal, {
      backdrop: 'static',
      keyboard: false,
    })
  },
  methods: {
    listenForIframeMessages() {
      window.addEventListener('message', (event) => {
        if (event.data.action === 'navigate' && event.data.lecture_id) {
          this.$router.push({
            name: 'lecture',
            params: { lecture: event.data.lecture_id },
          })
        }
      })
    },
    loginModal() {
      this.$refs.passwordLogin.open()
    },
    back() {
      return this.$api.back(this.$route.params.course)
    },
    showCongratsModal() {
      this.congratsModalInstance.show()
    },
    hideCongratsModal() {
      this.congratsModalInstance.hide()
    },
  },
  computed: {
    progress() {
      return this.$store.getters.lectureProgress
    },
  },
  watch: {
    progress(newValue, oldValue) {
      if (newValue === 100) {
        let slug = _.get(this.$route, 'params.course')
        let completed = window.localStorage.getItem(`${slug}.completed`)

        if (!completed) {
          window.localStorage.setItem(`${slug}.completed`, 1)
          confetti({
            particleCount: 200,
            spread: 200,
            origin: { y: 0.6 },
          })

          this.showCongratsModal()
        }
      }
    },
  },
}
</script>
